import { BabyArtDefinition } from "./IArtDef";
import * as rawJson from "./babyArtDefinition.json";

// @ts-ignore
export const babyArtDefinition: BabyArtDefinition = rawJson.default;
